import { render, staticRenderFns } from "@/modules/Book/templates/book-detail.html?vue&type=template&id=48ea1bce&scoped=true&"
import script from "@/modules/Book/scripts/book-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Book/scripts/book-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Book/styles/book-detail.scss?vue&type=style&index=0&id=48ea1bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea1bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
